import { createElement } from 'react';
import type { Factory } from 'core/base';

type DynamicComponentWithFactory = <T extends Factory<any, any>>(
  f: T,
  t?: any,
) => (p: any) => JSX.Element;

export const DynamicComponentHOC: DynamicComponentWithFactory = (factory, propType = 'type') => {
  return function (props: any) {
    const { [propType]: type } = props;
    const Component: React.FC = factory.create(type);

    return createElement(Component, props);
  };
};
